theme.headerSticky = (function() {
  function ScrollSticky(e){
    const headerStickyWrapper = document.querySelector('header');
    const headerStickyTarget = document.querySelector('.header__sticky');
    
    if(headerStickyTarget){
      // Calculate height once, not on every single scroll tick
      let headerHeight = headerStickyWrapper.clientHeight;
      let ticking = false;

      window.addEventListener('scroll', function() {
        // Prevent the event from firing dozens of times per frame
        if (!ticking) {
          window.requestAnimationFrame(function() {
            // Apply or remove the class smoothly
            if (window.scrollY > headerHeight) {
              headerStickyTarget.classList.add('sticky');
            } else {
              headerStickyTarget.classList.remove('sticky');
            }
            ticking = false;
          });
          
          ticking = true;
        }
      }, { passive: true }); // Tells the browser this scroll event won't block the screen
    }
  }
  return ScrollSticky;
})();